import { useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { Logo } from "../../components/Logo";
import { firstAllowedPath } from "../../lib/permissions";

export default function AdminLoginPage() {
  const { admin, login, configured } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (admin) return <Navigate to={firstAllowedPath(admin) || "/admin"} replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await login(username.trim(), password);
    } catch (err) {
      setError(err.message || "Could not sign in");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white grid place-items-center px-6">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-10">
          <Logo className="h-14 w-14" />
          <div>
            <div className="font-display text-3xl leading-none">Creative Flare</div>
            <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-[#EC4899] mt-2">Admin access</div>
          </div>
        </div>

        <form onSubmit={onSubmit} className="rounded-[32px] bg-white text-black p-8 md:p-10">
          <h1 className="font-display text-3xl">Sign in</h1>
          <p className="text-black/60 mt-2 text-sm">Use your admin username and password.</p>

          {!configured && (
            <p className="mt-6 text-sm text-[#BE185D] bg-[#EC4899]/10 border border-[#EC4899]/30 rounded-2xl p-4">
              Supabase is not configured yet. Add <code>REACT_APP_SUPABASE_URL</code> and{" "}
              <code>REACT_APP_SUPABASE_ANON_KEY</code> to <code>frontend/.env</code>, then run the SQL in{" "}
              <code>supabase/schema.sql</code>.
            </p>
          )}

          {error && (
            <p className="mt-6 text-sm text-[#BE185D] bg-[#EC4899]/10 border border-[#EC4899]/30 rounded-2xl p-4">
              {error}
            </p>
          )}

          <label className="block mt-8 font-mono text-xs uppercase tracking-[0.2em] text-black/55">Username</label>
          <input
            className="cf-input mt-2"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoComplete="username"
            required
          />

          <label className="block mt-6 font-mono text-xs uppercase tracking-[0.2em] text-black/55">Password</label>
          <input
            className="cf-input mt-2"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            required
          />

          <button
            type="submit"
            disabled={submitting || !configured}
            className="mt-10 w-full py-4 rounded-full bg-[#EC4899] text-white font-medium hover:bg-[#DB2777] disabled:opacity-50"
          >
            {submitting ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
